module.exports = __webpack_public_path__ + "static/media/firstlithoniachildhealth.03bdfce4.jpg";